import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';

interface ConfirmProps {
  title: string;
  content: string | JSX.Element;
  onClose: (event?: {}, reason?: 'backdropClick' | 'escapeKeyDown' | 'exit') => void;
  onConfirm: () => void;
}

export const ConfirmDialog = ({ title, content, onClose, onConfirm }: ConfirmProps) => {
  return (
    <Dialog onClose={onClose} fullWidth maxWidth={'sm'} open={true}>
      <DialogTitle sx={{ m: 0, p: 2 }}>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => onClose()}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{content}</DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={onConfirm}>
          TAK
        </Button>
        <Button variant="outlined" color="error" onClick={onClose}>
          NIE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
